module.exports = __webpack_public_path__ + "static/torm-DND3_FnP-d53061c35234ef8131a35dc639e8edf9.jpg";